//Components
import ItemDetailContainer from "../components/Main/ItemDetailContainer";

export default function DetailPage(){
    return(
        <ItemDetailContainer/>
    );
}